import { motion } from 'framer-motion';

const ErrorIcon = ({ ...props }) => (
  <motion.svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <mask id='mask0_420_32' maskUnits='userSpaceOnUse' x='0' y='0' width='14' height='14'>
      <rect width='14' height='14' fill='white' />
    </mask>
    <g mask='url(#mask0_420_32)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 14C3.13403 14 0 10.866 0 7C0 3.13403 3.13403 0 7 0C10.866 0 14 3.13403 14 7C14 10.866 10.866 14 7 14ZM7.65625 3.28125C7.65625 2.91878 7.36247 2.625 7 2.625C6.63753 2.625 6.34375 2.91878 6.34375 3.28125V8.09375C6.34375 8.45622 6.63753 8.75 7 8.75C7.36247 8.75 7.65625 8.45622 7.65625 8.09375V3.28125ZM6.34375 10.7188C6.34375 10.3563 6.63753 10.0625 7 10.0625C7.36247 10.0625 7.65625 10.3563 7.65625 10.7188C7.65625 11.0812 7.36247 11.375 7 11.375C6.63753 11.375 6.34375 11.0812 6.34375 10.7188Z'
        fill='var(--pcm-error-color)'
      />
    </g>
  </motion.svg>
);

export default ErrorIcon;
